import { html, type Html, View } from 'rune-ts';
import { CustomerOrder, ReceiptOption, ReceiptViewerType } from '../type';
import { font } from '../../../../shared/typography';
import format from 'date-fns/format/index.js';

export interface CardReceiptData {
  type: typeof ReceiptViewerType.CARD;
  customer_order: CustomerOrder;
  option: ReceiptOption;
}

export class CardReceiptViewer extends View<CardReceiptData> {
  protected override template({ customer_order, option }: CardReceiptData): Html {
    const { impt } = customer_order;

    return html`
      <div class="purchase-receipt-customer-order__info ${font('16_medium')}">
        <div class="purchase-receipt-customer-order__info-title ${font('16_bold')}">
          ${this.T.card_info_t}
        </div>
        <div class="purchase-receipt-customer-order__row">
          <div class="purchase-receipt-customer-order__info-left">
            ${this.T.card_name}/${this.T.apply_num}
          </div>
          <div class="purchase-receipt-customer-order__info-right purchase-receipt-customer-order__row--blue">
            ${impt.card_name} / ${impt.apply_num}
          </div>
        </div>
        <div class="purchase-receipt-customer-order__row">
          <div class="purchase-receipt-customer-order__info-left">${this.T.card_num}</div>
          <div class="purchase-receipt-customer-order__info-right">${impt.card_number}</div>
        </div>
        <div class="purchase-receipt-customer-order__row">
          <div class="purchase-receipt-customer-order__info-left">${this.T.card_quota}</div>
          <div class="purchase-receipt-customer-order__info-right">
            ${impt.card_type === null
              ? ''
              : impt.card_type == 0
                ? '신용카드'
                : '체크카드'}/${impt.card_quota == 0 ? '일시불' : impt.card_quota + '개월'}
          </div>
        </div>
        <div class="purchase-receipt-customer-order__row">
          <div class="purchase-receipt-customer-order__info-left">${this.T.paid_at_t}</div>
          <div class="purchase-receipt-customer-order__info-right">
            ${format(new Date(impt.paid_at * 1000), 'yyyy.MM.dd HH:mm:ss')}
          </div>
        </div>
        ${impt.cancel_amount > 0
          ? html`<div class="purchase-receipt-customer-order__row">
              <div class="purchase-receipt-customer-order__info-left">취소일자</div>
              <div class="purchase-receipt-customer-order__info-right">
                ${format(new Date(impt.cancelled_at * 1000), 'yyyy.MM.dd HH:mm:ss')}
              </div>
            </div>`
          : ''}

        <div class="purchase-receipt-customer-order__row">
          <div class="purchase-receipt-customer-order__info-left">${this.T.products_t}</div>
          <div class="purchase-receipt-customer-order__info-right">${option.name}</div>
        </div>
        <div class="purchase-receipt-customer-order__row">
          <div class="purchase-receipt-customer-order__info-left">${this.T.product_classification}</div>
          <div class="purchase-receipt-customer-order__info-right">일반상품</div>
        </div>
        <div class="purchase-receipt-customer-order__row">
          <div class="purchase-receipt-customer-order__info-left">구매번호</div>
          <div class="purchase-receipt-customer-order__info-right">${customer_order.id}</div>
        </div>
        ${option.up_c_id
          ? html`<div class="purchase-receipt-customer-order__row">
              <div class="purchase-receipt-customer-order__info-left">${this.T.up_c_id_t}</div>
              <div class="purchase-receipt-customer-order__info-right">${option.up_c_id}</div>
            </div>`
          : ''}
      </div>
    `;
  }

  get T() {
    return {
      card_info_t: ET('customer_order::receipt::detail::card_info'),
      apply_num: ET('customer_order::receipt::detail::apply_num'),
      card_name: ET('customer_order::receipt::detail::card_name'),
      card_num: ET('customer_order::receipt::detail::card_num'),
      card_quota: ET('customer_order::receipt::detail::card_quota'),
      paid_at_t: ET('customer_order::receipt::detail::paid_at'),
      products_t: ET('customer_order::receipt::products'),
      up_c_id_t: ET('customer_order::receipt::up_c_id'),
      product_classification: ET('customer_order::receipt::detail::product_classification'),
    };
  }
}
